import { Button } from '@eigtech/ui/components/button'
import { Plus, Trash } from 'lucide-react'
import { useArrayFieldContext } from './ArrayFieldContext'
import { useArrayFieldRowContext } from './ArrayFieldRowContext'

export type ArrayFieldAddButtonProps = React.ComponentProps<typeof Button>

export function ArrayFieldAddButton(props: ArrayFieldAddButtonProps) {
  const { isDisabled, ...buttonProps } = useArrayFieldAddButtonProps()

  return (
    <Button
      aria-label="Add Row"
      disabled={isDisabled}
      mode="icon"
      size="md"
      {...buttonProps}
      {...props}
    >
      <Plus />
    </Button>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useArrayFieldAddButtonProps() {
  const { append, defaultValue, max, fields } = useArrayFieldContext()

  const isDisabled = !!(max && fields.length >= max)

  return {
    isDisabled,
    onClick: () => append(defaultValue ?? {}),
    'data-slot': 'array-field-add-row-button',
  }
}

export type ArrayFieldRemoveButtonProps = React.ComponentProps<typeof Button>

export function ArrayFieldRemoveButton(props: ArrayFieldRemoveButtonProps) {
  const { isDisabled, ...buttonProps } = useArrayFieldRemoveButtonProps()

  return (
    <Button
      aria-label="Remove Row"
      disabled={isDisabled}
      mode="icon"
      size="md"
      variant="destructive-outline"
      {...buttonProps}
      {...props}
    >
      <Trash />
    </Button>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useArrayFieldRemoveButtonProps() {
  const { min, fields } = useArrayFieldContext()
  const { isFirst, remove, index } = useArrayFieldRowContext()

  const isDisabled = isFirst && !!(min && fields.length <= min)

  return {
    isDisabled,
    onClick: remove,
    'data-slot': 'array-field-remove-row-button',
    'data-row-index': index,
  }
}
